import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getClients = createAsyncThunk("clients/getClients", async () => {
  try {
    const response = await magnifiAPI.getClients();

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const addClient = createAsyncThunk("clients/addClient", async (payload) => {
  try {
    const response = await magnifiAPI.addClient(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateClient = createAsyncThunk("clients/updateClient", async (payload) => {
  try {
    const response = await magnifiAPI.updateClient(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteClient = createAsyncThunk("clients/deleteClient", async (payload) => {
  try {
    const response = await magnifiAPI.deleteClient(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
